import { useQuery } from '@apollo/client/react';
import { CreditUsageDocument, type CreditUsageFieldsFragment } from '@/graphql';

export interface CreditUsageResult {
  /** The caller's credit usage; `null` for a documents payer, or while unknown. */
  creditUsage: CreditUsageFieldsFragment | null;
  /** True until the first answer; a failed query counts as answered. */
  loading: boolean;
}

/**
 * The caller's credit usage from the cache. `useCreditUsageLive`, mounted once per session in
 * `SessionChrome`, keeps that cache entry current.
 */
export function useCreditUsage(): CreditUsageResult {
  const { data, loading } = useQuery(CreditUsageDocument, { fetchPolicy: 'cache-first' });
  return {
    creditUsage: data?.creditUsage ?? null,
    loading: loading && data === undefined
  };
}
